declare var swal: any;
import { Component, ViewEncapsulation, Input, ChangeDetectionStrategy, OnInit, ViewChild, ElementRef } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbModalRef, NgbDateStruct, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
//import { FileUploader } from 'ng2-file-upload/ng2-file-upload';
import { ApiResponseModel } from '../../../../models/api_response_model';
import { ApiRequestModel } from '../../../../models/api_request_model';
import { SpinnerService } from '../../../../services/spinner.service';
import { AppData } from '../../../../models/appdata';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { HCPService } from '../../../../services/hcp.service';
import * as alertFunctions from '../../../../../shared/data/sweet-alerts';
import { NGXToastrService } from '../../../../../shared/services/toastr.service';
import { ActorService } from '../../../../services/actor.service';
import { FDService } from '../../../../services/fd.service';
import { ConsultantMapPipe } from '../../../../pipes/actors/actorIdentity.pipes';


@Component({
  selector: 'ngbaddcredentials',
  templateUrl: './addcredentials.modal.html',
  styleUrls: ['./addcredentials.modal.scss']
})

export class NgbAddCredentialsModal implements OnInit {
  @ViewChild('f') IdentitiesForm: NgForm;

  searchTitle: string;
  public ApiResData: ApiResponseModel;

  public isRequesting: boolean = false;

  constructor(public activeModal: NgbActiveModal, private loaderService: SpinnerService,
    private actorservice: ActorService, private fdservice: FDService, private filter: ConsultantMapPipe,
    private router: Router, private route: ActivatedRoute, private modalService: NgbModal, private hcpservice: HCPService, private parserFormatter: NgbDateParserFormatter,
    private tosterservice: NGXToastrService) { }
  ngOnInit() {


  }


  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }

}
